import DATES from 'constants/dates';

// Date values to watch for stale dates
export const dateValueListToObserve = [
   'TODAY',
   'YESTERDAY',
   'LAST_SEVEN_DAYS',
   'LAST_THIRTY_DAYS',
];

const dateRangeOptions = [
   {
      value: 'TODAY',
      label: 'Today',
      getDateFrom: DATES.today.getDayStart,
      getDateTo: DATES.today.getDayEnd,
      getDateFromStr: DATES.today.getDateStr,
      getDateToStr: DATES.today.getDateStr,
   },
   {
      value: 'YESTERDAY',
      label: 'Yesterday',
      getDateFrom: DATES.yesterday.getDayStart,
      getDateTo: DATES.yesterday.getDayEnd,
      getDateFromStr: DATES.yesterday.getDateStr,
      getDateToStr: DATES.yesterday.getDateStr,
   },
   {
      value: 'LAST_SEVEN_DAYS',
      label: 'Last 7 Days',
      getDateFrom: DATES.sevenDaysAgo.getDayStart,
      getDateTo: DATES.today.getDayEnd,
      getDateFromStr: DATES.sevenDaysAgo.getDateStr,
      getDateToStr: DATES.today.getDateStr,
   },
   {
      value: 'LAST_THIRTY_DAYS',
      label: 'Last 30 Days',
      getDateFrom: DATES.thirtyDaysAgo.getDayStart,
      getDateTo: DATES.today.getDayEnd,
      getDateFromStr: DATES.thirtyDaysAgo.getDateStr,
      getDateToStr: DATES.today.getDateStr,
   },
   {
      value: 'CUSTOM',
      label: 'Custom',
      getDateFrom: DATES.yesterday.getDayStart,
      getDateTo: DATES.today.getDayEnd,
      getDateFromStr: DATES.yesterday.getDateStr,
      getDateToStr: DATES.today.getDateStr,
   },
];

export default dateRangeOptions;
